var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-blog-categories",
                              title: _vm.getTitle
                                ? `${_vm.getTitle} категория блога`
                                : `Создать категорию блога`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "PageContent",
                            [
                              _c(
                                "v-container",
                                [
                                  _c("InputTitleSlug", {
                                    attrs: {
                                      "is-loading": _vm.loading || _vm.disabled,
                                      title: _vm.fields.title,
                                      "title-error": _vm.validationErrors.title,
                                      slug: _vm.fields.slug,
                                      "slug-error": _vm.validationErrors.slug,
                                      isSlugEnabled: !_vm.isNew,
                                    },
                                    on: {
                                      "change:title": function ($event) {
                                        _vm.fields.title = $event
                                      },
                                      "change:slug": function ($event) {
                                        _vm.fields.slug = $event
                                      },
                                      "input:slug": _vm.$v.fields.slug.$touch,
                                    },
                                  }),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v("Анонс ("),
                                              _c("TranslationIcon"),
                                              _vm._v(")"),
                                            ],
                                            1
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.announcement,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "announcement",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.announcement",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("SeoSettings", {
                                            attrs: {
                                              data: _vm.data,
                                              loading:
                                                _vm.loading || _vm.disabled,
                                            },
                                            on: {
                                              "on-input-seo": function (
                                                $event
                                              ) {
                                                _vm.fields = Object.assign(
                                                  {},
                                                  _vm.fields,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _vm.isNew
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isShowSortOrder: "",
                          "is-new": _vm.isNew,
                          "is-loading": _vm.loading,
                          "iis-show-btn-submit": _vm.disabled,
                          "entity-type": "blogCategory",
                          sortOrder: _vm.fields.sortOrder,
                          language: _vm.language,
                          translations: _vm.fields.translations,
                        },
                        on: {
                          delete: function ($event) {
                            return _vm.$emit("delete-blog-category")
                          },
                          cancel: function ($event) {
                            return _vm.$router.push({
                              name: "page-blog-categories",
                            })
                          },
                          submit: _vm.submit,
                          "update-translations": function ($event) {
                            return Object.assign(
                              _vm.fields.translations,
                              $event
                            )
                          },
                          "language-update": function ($event) {
                            return _vm.$emit("language-update", $event)
                          },
                          "update-sort-order": function ($event) {
                            _vm.fields.sortOrder = Number($event)
                          },
                        },
                      })
                    : _vm.data
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isShowSortOrder: "",
                          "is-new": !_vm.data.id,
                          "created-at": _vm.data.createdAt,
                          "updated-at": _vm.data.updatedAt,
                          "is-loading": _vm.loading,
                          "iis-show-btn-submit": _vm.disabled,
                          "entity-id": _vm.data.id,
                          "entity-type": "blogCategory",
                          language: _vm.language,
                          translations: _vm.fields.translations,
                          sortOrder: _vm.fields.sortOrder,
                        },
                        on: {
                          delete: function ($event) {
                            return _vm.$emit("delete-blog-category")
                          },
                          cancel: function ($event) {
                            return _vm.$router.push({
                              name: "page-blog-categories",
                            })
                          },
                          submit: _vm.submit,
                          "update-translations": function ($event) {
                            return Object.assign(
                              _vm.fields.translations,
                              $event
                            )
                          },
                          "language-update": function ($event) {
                            return _vm.$emit("language-update", $event)
                          },
                          "update-sort-order": function ($event) {
                            _vm.fields.sortOrder = Number($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }